/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBranchService } from "../../entities/models/BranchService";
import { z } from "zod/v4";

export const modelsBranchServiceSchema = z.object({
    "branch_id": z.optional(z.int()),
"company_id": z.optional(z.int()),
"created_at": z.optional(z.string()),
"discount_type": z.optional(z.string()),
"discount_value": z.optional(z.number()),
"duration_minutes": z.optional(z.int()),
"id": z.optional(z.int()),
"is_active": z.optional(z.boolean()),
"price": z.optional(z.number()),
"service_id": z.optional(z.int()),
"service_name": z.optional(z.string()),
"updated_at": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBranchService>